import TableRatesData from "./TableRatesData";

export default TableRatesData